import type { RouteRecordRaw } from "vue-router";

export const DatabasesRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'databasesList',
        component: () => import('./components/ListDatabase.vue')
    },
    {
        path: ':databaseName',
        name: 'databasesView',
        component: () => import('./components/ViewDatabase.vue')
    }
]